import React from 'react';
import { Container, Grid, Box, Typography, Card, CardContent } from '@mui/material';
import { School, TrendingUp, EmojiEvents, Favorite, Groups2, Timer } from '@mui/icons-material';

export const WhyUsSection: React.FC = () => {
    const benefits = [
        {
            icon: School,
            title: 'Experienced Tutors',
            description: 'Dedicated teachers who know how to build skills and confidence.',
        },
        {
            icon: TrendingUp,
            title: 'Structured Curriculum',
            description: 'Aligned with 11+ requirements, with clear progression and targets.',
        },
        {
            icon: EmojiEvents,
            title: 'Confidence & Results',
            description: 'Focus on accuracy, speed, exam techniques, and strong fundamentals.',
        },
        {
            icon: Groups2,
            title: 'Small Group Learning',
            description: 'Maximum 1-2 students per class ensures personalized attention for every child.',
        },
        {
            icon: Favorite,
            title: 'Supportive Environment',
            description: 'We encourage growth mindset and celebrate progress, not just perfection.',
        },
        {
            icon: Timer,
            title: 'Flexible Scheduling',
            description: 'Convenient class times that work around your family\'s busy schedule.',
        },
    ];

    return (
        <Box
            id="why"
            sx={{
                py: { xs: 8, md: 12 },
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    sx={{
                        mb: 2,
                        textAlign: 'center',
                        background: 'linear-gradient(135deg, #5b4cdb 0%, #1e293b 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                >
                    Why Choose Myl ?
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        mb: 6,
                        textAlign: 'center',
                        color: 'text.secondary',
                        maxWidth: 700,
                        mx: 'auto',
                        lineHeight: 1.8,
                    }}
                >
                    We combine expert teaching, proven methods, and a nurturing environment
                    to help every student reach their full potential.
                </Typography>

                <Grid container spacing={3}>
                    {benefits.map((benefit, index) => {
                        const Icon = benefit.icon;
                        return (
                            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={index}>
                                <Card sx={{ height: '100%', textAlign: 'center' }}>
                                    <CardContent sx={{ p: 4 }}>
                                        <Box
                                            sx={{
                                                width: 64,
                                                height: 64,
                                                borderRadius: 3,
                                                background: 'linear-gradient(135deg, #5b4cdb 0%, #06b6d4 100%)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mx: 'auto',
                                                mb: 3,
                                            }}
                                        >
                                            <Icon sx={{ color: '#fff', fontSize: 32 }} />
                                        </Box>
                                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                                            {benefit.title}
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                                            {benefit.description}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>

                {/* Success Story Highlight */}
                <Box
                    sx={{
                        mt: 6,
                        p: 4,
                        borderRadius: 3,
                        background: 'linear-gradient(135deg, rgba(91, 76, 219, 0.05) 0%, rgba(6, 182, 212, 0.05) 100%)',
                        border: '1px solid rgba(91, 76, 219, 0.15)',
                        textAlign: 'center',
                    }}
                >
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#5b4cdb' }}>
                        Join Our Success Story
                    </Typography>
                    <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                        Our students consistently achieve places at top grammar schools. With the right
                        guidance, practice, and support, your child can too. Let's work together to make it happen.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};
